import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/expiration';

export class ExpirationService extends RestServiceConnection {

    listExpirations = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: { ...filters }
        }, true) as AxiosResponse;
        return this;
    }

    listRemittances = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-sepa-documents',
            data: { ...filters }
        }, true) as AxiosResponse;
        return this;
    }

    confirmRemittances = async (sepaDocumentIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/confirm-sepa-documents',
            data: { sepaDocumentIds }
        }, true) as AxiosResponse;
        return this;
    }

    getExpiration = async (expirationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { expirationId }
        }, true) as AxiosResponse;
        return this;
    }

    createExpiration = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: values
        }, true) as AxiosResponse;
        return this;
    }

    editExpiration = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: values
        }, true) as AxiosResponse;
        return this;
    }

    deleteExpiration = async (expirationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { expirationId }
        }, true) as AxiosResponse;
        return this;
    }

    deleteMultiExpirations = async (expirationIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { expirationIds }
        }, true);
        return this;
    }

    getPaymentMethods = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/obtain-payment-methods',
        }, true);
        return this;
    }

    getExpirationStatuses = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/get-expiration-statuses',
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    getExpirationManagementStatuses = async () => {
        this.response = await this.makeRequest({
            method: 'GET',
            url: ENDPOINT + '/get-expiration-management-statuses',
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    changeExpirationStatus = async (expirationId: string, statusId: string, comment?: string, koReasonId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-expiration-status',
            data: { expirationId, statusId, comment, koReasonId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    changeExpirationManagementStatus = async (expirationId: string, statusId: string, comment: string, koReasonId?: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/change-expiration-management-status',
            data: { expirationId, statusId, comment, koReasonId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    markAsPaid = async (expirationId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/mark-as-paid',
            data: { expirationId }
        }, true);
        return this;
    }

    exportExpirationsCSV = async (expirationIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-csv',
            data: { expirationIds },
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

    exportExpirationsXLSX = async (expirationIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/export-xlsx',
            data: { expirationIds },
            responseType: 'arraybuffer',
        }, true);
        return this;
    }

    downloadDocuments = async (documentId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/download-documents',
            data: { documentId },
        }, true);
        return this;
    }

    listBanks = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-banks',
            data: { ...filters }
        }, true);
        return this;
    }

    obtainExpirationsToGenerateSEPA = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/obtain-expirations-to-generate-sepa-file',
            data: { ...filters }
        }, true);
        return this;
    }

    generateSEPA = async (values: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/generate-sepa',
            data: values
        }, true);
        return this;
    }

    importSepaReturnsXLSX = async (sepaReturnsExcelFile: File, bankName?: string) => {
        const formData = new FormData();
        formData.append('sepaReturnsExcelFile', sepaReturnsExcelFile);
        if (bankName) {
            formData.append('bankName', bankName);
        }

        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/import-sepa-returns',
            data: formData,
            headers: { "Content-Type": "multipart/form-data" }
        }, true) as AxiosResponse;
        return this;
    }

}
